import {Pipe, PipeTransform} from '@angular/core';
import {Category, QuickscanDefinition, TisDefinition} from '../models';
import {Question} from '../models/definition/question';
import {BehaviorSubject, Observable} from 'rxjs';
import {ProjectAnalysisDefinition} from "../models/project-analysis";

@Pipe({
    name: 'categoryGetAllSubCategoryQuestions',
    standalone: false
})
export class CategoryGetAllSubCategoryQuestionsPipe implements PipeTransform {

    transform(category: Category): Observable<Question[]> {
        const questions$ = new BehaviorSubject<Question[]>(category.getAllSubCategoryQuestions());
        const parent = category.getParent();

        if (parent instanceof QuickscanDefinition || parent instanceof TisDefinition || parent instanceof ProjectAnalysisDefinition) {
            parent.onChange.subscribe(() => {
                questions$.next(category.getAllSubCategoryQuestions());
            });
        }

        return questions$.asObservable();
    }

}
